import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "hidden"
}

import { inject, provide, Ref, ref, useSlots } from 'vue';
import { filterItems } from '@/utils';
import { OverviewCategory, OverviewFilter } from '@/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'OverviewFilter',
  props: {
    name: {},
    index: {},
    filterKey: {},
    categories: {}
  },
  setup(__props: any) {

const props = __props;



const slots = useSlots();

const categories: Ref<OverviewCategory[]> = ref([]);
const registered = ref(false);

const registerOverviewFilter =
    inject<(filter: OverviewFilter) => undefined>('registerOverviewFilter');

provide('registerOverviewCategory', registerCategory);

function registerCategory(category: OverviewCategory) {
    categories.value.push(category);
    if (slots.default().filter(filterItems).length === categories.value.length) {
        registered.value = true;
        registerOverviewFilter({ ...props, categories: categories.value });
    }
}

return (_ctx: any,_cache: any) => {
  return (!registered.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default", { categories: categories.value })
      ]))
    : _createCommentVNode("", true)
}
}

})